<template>
  <v-card tile height="auto" width="100%" class="wdgt_font_dims card-scroll par_">
    <v-container fluid style="height:auto;width:100%" class="mb-0 pb-0 mt-0">
      <v-row style="height:20%;width:100%" class="">
        <v-col :cols=" $vuetify.breakpoint.width < 1249 ? '4 offset-1' : '3 offset-1 ' " >
          <v-row
            class="my-0 "
            style="height:100%;width:100%"
            align="center"
          >
            <h3 class="pop_con_wdg">{{ $t('widgets.setUpPopupLive') }}</h3>
          </v-row>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.width < 976 ? '2' : $vuetify.breakpoint.width < 1249 ? '3' :  '5'" class="">
          <v-switch v-model="live" inset
                    color="#006AFF"
                    @change="wdgtLive()">
          </v-switch>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.width < 976 ? '5' : $vuetify.breakpoint.width < 1249 ? '4' :'3'">
          <v-row
            class="my-0 mr-2"
            style="height:100%;width:100%"
            justify="end"
            align="center"
          >
            <!-- save button -->
            <v-btn
              tile
              :class="!detectChange ? 'mb-2 sv_changes wdgt_font_dims resp_sp' : 'mb-2 wdgt_font_dims resp_sp'"
              :disabled="detectChange"
              @click="svChanges"
              outlined
            >
              {{ $t("widgets.svBtn") }}

            </v-btn>
          </v-row>
        </v-col>

      </v-row>
      <span style="color: red" v-if="discCodeNotValid " class="d-flex justify-end mr-9">  {{ $t("widgets.requiredValidCode") }}</span>
      <span style="color: red" v-if="triggerMustBe " class="d-flex justify-end mr-9">  {{ $t("widgets.requiredTrigger") }}</span>
      <v-row class=" pt-4">
        <v-col cols="9 offset-1 d-flex align-center" class="py-0 px-0">
          <h3 class="subs_title gath_msg">{{ $t("widgets.GathMess") }}</h3>
        </v-col>
        <v-col cols="2" class="row justify-end pr-9 ma-0  py-0 px-0">
          <TooltipIcon
            :posRight="true"
            :nudgeBottom="30"
            :nudgeLeft="5"
            :txt="$t('widgets.channelsInfo')"
            class="infoicon_scale pt-0 mt-0"
          />
        </v-col>
      </v-row>

      <v-col class="pa-0 parent_gat_message">
        <!--      <draggable v-model="coneData" class="row pl-4 pr-5 mb-6">-->
        <v-col  v-for="(ite,ke) in coneData" :key="ke+'item.id'" cols="11 offset-1"
                :class="notSel?'notSelSpc pl-0 mt-6 height_row':'pl-0 mt-0 height_row'" align-self="end">
          <small :class="notSel?'notSelTxt mt-10':''" v-if="notSel">{{ $t("widgets.notSelTxt") }}</small>
          <v-col cols="12" class="connection_row height_row row py-0 my-0 pl-2 pr-0" row style="height: 36px !important;"
                 :class="notSel?'notSel connection_row height_row row py-0 my-0 pl-2 pr-0':'connection_row height_row row py-0 my-0 pl-2 pr-0'">
            <v-col cols="6" class="py-0 my-0 " >
              <v-checkbox
                v-model="ite.connection"
                :label="$t(getDisplayAvailabilityNotice(ite))"
                class="mt-0 mb-0"
                :disabled="detectEuRegion && ite.title == 'Facebook'"
              >
              </v-checkbox>

            </v-col>
            <v-col class="pt-0 d-flex justify-end Eu_hint_NotAv">
              <span v-if="detectEuRegion && ite.title == 'Facebook'">{{ $t("widgets.notAvEU") }}</span>
            </v-col>
            <v-col  cols="1 " class="pl-0 pr-0 pb-0 pt-2" justify="end" :class="detectEuRegion ? 'disabled_display pt-0' : ''" style="height: 35px !important;">
              <v-row aligns="center" justify="center" :class="activeIconArrow == ke + 1 ? 'arrow_icon_fill' : ''"
                      @mouseenter="activeIconArrow = ke + 1" @mouseleave="activeIconArrow = false"
                     style="height:11px !important;" @click="tpMove(coneData,ke,ke == 0 ?  2 : ke == 1 ?  -2 : -1)">
                <arrow-up class="cursPoint" />
              </v-row>
              <v-row style="height: 5px"></v-row>
              <v-row aligns="center" justify="center" :class="activeIconArrowSecond == ke + 3 ? 'arrow_icon_fill' : ''"
                     @mouseenter="activeIconArrowSecond = ke + 3" @mouseleave="activeIconArrowSecond = false"
                     style="height:11px !important;" @click="btMove(coneData,ke,ke == 0 ?  1 : ke == 1 ?  2 : 0)">
                <arrow-down class="cursPoint" />
              </v-row>
            </v-col>
          </v-col>
        </v-col>
      </v-col>
     </v-container>
    <v-divider ></v-divider>
    <v-container>
    <v-row class="Sub_Par">
        <v-col cols="6 offset-1 py-0 px-0" class="py-0 align-end">
          <h3 class="subs_title gath_msg">{{ $t("widgets.subsType") }}</h3>
        </v-col>
        <v-col cols="5" class="justify-end row pr-6 py-0 mr-0">
          <TooltipIcon
            :posRight="true"
            :nudgeBottom="30"
            :nudgeLeft="5"
            :txt="$t('widgets.subscribeInfo')"
            class="infoicon_scale pt-0 mt-0"
          />
        </v-col>
        <v-col cols="12 offset-1 py-0 px-0">
          <p class="subs_text widg_hint_txt">{{$t("widgets.discText")}}</p>
        </v-col>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.width < 1550 ? '3 offset-1' : '2 offset-1'" class="par_spc py-0 mb-0 px-0">
            <v-checkbox
              @change="def_selected == '' ? discount_selected = 'subscribe' : discount_selected = ''"
              v-model="def_selected"
              value="deafult"
              :label="$t('widgets.subscribeTypeNoDiscount')"
              class="mt-0 ml-2"
            ></v-checkbox>
          </v-col >
          <v-col class="py-0">
            <v-checkbox
              @change="discount_selected == '' ? discount_selected = 'deafult' : def_selected = ''"
              v-model="discount_selected"
              value="subscribe"
              class="checkbox_widget mt-0 mb-0"
              :label="$t('widgets.subscribeTypeDiscount')"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
    <v-container class="py-0">
      <v-row class="py-0">
        <v-col cols="11 offset-1" v-if="def_selected == ''" class="px-0 py-0">
          <v-row  class="py-0 par_disc_fields wdg_disc_codes">
            <v-container fluid style="height:auto;width:100%" class="mb-0 pb-0 px-6 py-0 pos_smaller">
              <v-row align="start" style="height:30% width:100%" class="mb-0 pb-0 py-0">
                <v-col cols="11" class="py-0 mb-0 pl-0 pr-0">
                  <v-text-field
                    v-model="discount_statement"
                    @focus="discount_statement_focus = true"
                    @focusout="discount_statement_focus = false"
                    :label="$t('widgets.discState')"
                    class="mb-0"
                    :value="discount_statement"
                    maxlength="40"
                    :rules=" [v => v.length <= 40 || 'Max 40 characters']"
                  >
                    <template v-slot:label v-if="discount_statement_focus" >
                      <span >{{$t('widgets.discState')}}</span>
                      <span v-if="discount_statement.length > 4" style="position: absolute;right: 18px;">{{discount_statement.length}}/</span>
                      <span v-if="discount_statement.length > 4" style="position: absolute;right: 0px;">40</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="1"></v-col>
              </v-row>
            </v-container>
            <v-container class="pr-12 py-0 pos_sm_cont">
              <v-col cols="12" class="pl-0 pr-2 py-0 d-flex justify-start">
                <small class="smaller_text space_bottom ">{{$t('widgets.discSmallText')}}<b>{{ $t('widgets.discMarkHint')}}</b>
<!--                  {{$t('widgets.discSmallTextManualCoupon')}}-->
                </small>
              </v-col>
            </v-container>
              <v-col cols="5" class="py-0 mb-0 pr-0">
                <v-text-field
                  v-model="discount_code"
                  @focus="discount_code_focus = true"
                  @focusout="discount_code_focus = false"
                  :label="$t('widgets.addYourDiscCode')"
                  class="mb-0 dis_code"
                  :class="discCodeNotValid ? 'not_valid' : ''"
                  :value="discount_code"
                  maxlength="20"
                  :rules=" [v => v.length <= 20 || 'Max 20 characters']"
                >
                  <template v-slot:label v-if="discount_code_focus">
                    <span >{{$t('widgets.addYourDiscCode')}}</span>
                    <span v-if="discount_code.length > 4" style="position: absolute;right: 18px;">{{discount_code.length}}/</span>
                    <span v-if="discount_code.length > 4" style="position: absolute;right: 0px;">20</span>
                  </template>
                </v-text-field>
                <!--              :rules="nameRules"-->
              </v-col>
              <v-col cols="1" style="width: 33px !important;" class="px-0"></v-col>
              <v-col cols="5" class="py-0 mb-0 pl-0">
<!--                <v-btn block  color="primary"-->
<!--                >-->
<!--                  {{$t('widgets.discCopyCode')}}-->
<!--                </v-btn>-->
                <v-text-field
                  v-model="copy_discount_code_button "
                  @focus="copy_discount_code_button_focus = true"
                  @focusout="copy_discount_code_button_focus = false"
                  :label="$t('widgets.discCopyCode')"
                  class="mb-0 txt_overflow_wdg_cdc"
                  :value="$t('widgets.discCopyCode')"
                  maxlength="22"
                  :rules=" [v => v.length <= 22 || 'Max 22 characters']"
                >
<!--                  v-model="discount_statement"-->
<!--                  :value="discount_statement"-->
<!--                  maxlength="25"-->
<!--                  :rules=" [v => v.length <= 25 || 'Max 25 characters']"-->
                  <template v-slot:label v-if="copy_discount_code_button_focus">
                    <span >{{$t('widgets.discCopyCode')}}</span>
                    <span v-if="copy_discount_code_button .length > 4" style="position: absolute;right: 18px;">{{copy_discount_code_button .length}}/</span>
                    <span v-if="copy_discount_code_button .length > 4" style="position: absolute;right: 0px;">22</span>
                  </template>
                </v-text-field>
              </v-col>


            <v-container fluid style="height:auto;width:100%" class="mb-0 mt-5 pb-0 px-6 py-0 pos_smaller">
              <v-row align="start" style="height:30% width:100%" class="mb-0 pb-0 py-0">
                <v-col cols="11" class="py-0">
                  <v-row align="start" style="height:70%" class="mb-0 pb-0 py-0">
                    <v-text-field
                      v-model="apply_discount_instruction"
                      :label="$t('widgets.discountLabelinstruction')"
                      class="text-fonts"
                      :value="apply_discount_instruction"
                      maxlength="80"
                      @focus="apply_discount_instruction_focus = true"
                      @focusout="apply_discount_instruction_focus = false"
                      :rules=" [v => v.length <= 80 || 'Max 80 characters']"
                    >
                      <template v-slot:label v-if="apply_discount_instruction_focus">
                        <span >{{$t('widgets.discountLabelinstruction')}}</span>
                        <span v-if="apply_discount_instruction.length > 4" style="position: absolute;right: 18px;">{{apply_discount_instruction.length}}/</span>
                        <span v-if="apply_discount_instruction.length > 4" style="position: absolute;right: 0px;">80</span>
                      </template>
                    </v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="1"></v-col>
              </v-row>
            </v-container>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="mt-0"></v-divider>
    <v-container>
      <v-row class="Sub_Par">
        <v-col cols="6 offset-1 py-0 px-0" class="py-0 align-end">
          <h3 class="subs_title gath_msg">{{ $t("widgets.popupTriger") }}</h3>
        </v-col>
        <v-col cols="5" class="justify-end row pr-6 py-0 mr-0" style="height: 28px !Important">
          <TooltipIcon
            :posRight="true"
            :nudgeBottom="30"
            :nudgeLeft="5"
            :txt="$t('widgets.hintTooltpiconHeader')"
            class="infoicon_scale pt-0 mt-0"
          />
        </v-col>
        <v-col class="pa-0 mb-4 py-0" >
<!--          <v-col cols="12 offset-1">-->
<!--            <v-col :class="{ 'red-valid-border': triggerMustBe }" class="px-0 py-0  "  cols="12">-->
            <v-col    cols="11 offset-1"
                      class="pl-0 py-0 mt-0 mb-0 height_row" align-self="end" >
              <!--            <small :class="notSel?'notSelTxt mt-10':''" v-if="notSel">{{ $t("widgets.notSelTxt") }}</small>-->
              <v-col cols="12" class="py-0 height_row row py-0 my-0 pl-2 pr-0" row>
                <!--              <v-col cols="" class="py-0 p
                x-0 my-0 trigger_width_230" >-->
                <div style="width: 271px !important; height: 35px" :class="{ 'red-valid-border': triggerMustBe }">
                  <v-checkbox
                    v-model="popup_triggers_add_to_cart"
                    class="mt-0 mb-0"
                  >
                    <span slot="label"  :class="popup_triggers_add_to_cart ?'blue_color':'trigger_ft_span'">{{$t('widgets.triggerAddToCart')}}</span>
                  </v-checkbox>
                </div>
                <!--                <div>-->

                <!--                </div>-->

                <!--              </v-col>-->
                <v-col class="pt-0 pl-0 d-flex justify-end ">
                  <TooltipIcon
                    :posRight="true"
                    :nudgeBottom="30"
                    :nudgeLeft="5"
                    :txt="$t('widgets.hintTooltpiconTrrigerOne')"
                    class="infoicon_scale pt-0 mt-0"
                  />
                </v-col>
              </v-col>
            </v-col >
            <v-col    cols="11 offset-1"
                      class="pl-0 py-0 mt-0 height_row" align-self="end">
              <!--            <small :class="notSel?'notSelTxt mt-10':''" v-if="notSel">{{ $t("widgets.notSelTxt") }}</small>-->
              <v-col cols="12" class=" height_row row py-0 my-0 pl-2 pr-0" row>
                <!--              <v-col cols="" class="py-0 px-0 my-0 trigger_width_230" >-->
                <div style="width: 271px !important;height: 35px" :class="{ 'red-valid-border': triggerMustBe && subPlan !== 'Free'}">
                  <v-checkbox
                    v-model="popup_triggers_exit_intent"
                    class="mt-0 mb-0"
                    :disabled="subPlan == 'Free'"
                  >
                    <!--                    disabled-->
                    <template v-slot:label>
                      <span :class="popup_triggers_exit_intent && subPlan !== 'Free' ? 'blue_color':'trigger_ft_span'" :disabled="subPlan == 'Free'">{{$t('widgets.triggerExistIntent')}}</span>
                      <v-col v-if="subPlan == 'Free'">
                        <v-img src="../../assets/img/Subscribers/icon-premium.png" width="16px" height="13px"></v-img>
                      </v-col>
                    </template>
                  </v-checkbox>
                </div>
                <!--              </v-col>-->
                <v-col class="pt-0 pl-0 d-flex justify-end">
                  <TooltipIcon
                    :posRight="true"
                    :nudgeBottom="30"
                    :nudgeLeft="5"
                    :txt="$t('widgets.hintTooltpiconTrrigerSec')"
                    class="infoicon_scale pt-0 mt-0"
                  />
                </v-col>
              </v-col>
            </v-col>
<!--        </v-col>-->
<!--        </v-col>-->


          <v-col cols="11 offset-1" class="pl-0  pr-8  py-0" v-if="subPlan == 'Free'">
            <v-col class="trigger_text pl-0 py-0">
              <v-col class="pl-5 brd_dot">
                {{$t('widgets.EUregionHint')}}
                <a  :href="upgrdUrl" target="_blank" class="upgrade_text_yellow"> {{$t('widgets.EUregionUpgrade')}}</a>
              </v-col>

            </v-col>
          </v-col>
        </v-col>

        <!--        <v-col cols="12 offset-1 py-0 px-0">-->
        <!--          <p class="subs_text widg_hint_txt">{{$t("widgets.discText")}}</p>-->
        <!--        </v-col>-->
        <!--        <v-row>-->
        <!--          <v-col :cols="$vuetify.breakpoint.width < 1550 ? '3 offset-1' : '2 offset-1'" class="par_spc py-0 mb-0 px-0">-->
        <!--            <v-checkbox-->
        <!--              @change="def_selected == '' ? discount_selected = 'subscribe' : discount_selected = ''"-->
        <!--              v-model="def_selected"-->
        <!--              value="deafult"-->
        <!--              :label="$t('widgets.subscribeTypeNoDiscount')"-->
        <!--              class="mt-0 ml-2"-->
        <!--            ></v-checkbox>-->
        <!--          </v-col >-->
        <!--          <v-col class="py-0">-->
        <!--            <v-checkbox-->
        <!--              @change="discount_selected == '' ? discount_selected = 'deafult' : def_selected = ''"-->
        <!--              v-model="discount_selected"-->
        <!--              value="subscribe"-->
        <!--              class="checkbox_widget mt-0 mb-0"-->
        <!--              :label="$t('widgets.subscribeTypeDiscount')"-->
        <!--            ></v-checkbox>-->
        <!--          </v-col>-->
        <!--        </v-row>-->
      </v-row>
    </v-container>
    <v-divider ></v-divider>
    <v-container>
      <v-row style="height:20%;width:100%" class="pa-0 ma-0" align="start">
        <v-col cols="6 offset-1" class="align-center pl-0">
          <v-row class="my-2 " style="width:100%" align="center">
            <h3 class="subs_title gath_msg">{{ $t("widgets.modalHdr") }}</h3>
          </v-row>
        </v-col>
        <v-col cols="5">
          <v-row class="my-0 mr-2" style="width:100%" justify="end">
            <TooltipIcon
              :posRight="true"
              :nudgeBottom="30"
              :nudgeLeft="5"
              :txt="$t('widgets.customizePopupHint')"
              class="infoicon_scale pt-0 mt-0"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row style="height:20%;width:100%" align="center">
        <v-col cols="1"></v-col>
        <v-col cols="4">
          <v-row align="center">
            <ColorSelect
              :color="hdrColor"
              :label="$t('widgets.hdrColor')"
              v-on:selectedColor="setHdrClr($event)"
              :key="hdrKey"
              class="item-scale"
              style="width:auto"
            />
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row align="center">
            <ColorSelect
              :color="bdyColor"
              :label="$t('widgets.bdyColor')"
              v-on:selectedColor="setBdyClr($event)"
              :key="bdyKey"
              class="item-scale"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container fluid style="height:auto;width:100%" class="mb-0 pb-0">
      <v-row align="start" style="height:30% width:100%" class="mb-0 pb-0">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <v-row align="start" style="height:70%" class="mb-0 pb-0 wdg_disc_codes">
            <v-text-field
              :label="$t('widgets.ttlTxt')"
              v-model="ttlText"
              class="text-fonts"
              maxlength="25"
              @focus="ttlText_focus = true"
              @focusout="ttlText_focus = false"
              :rules=" [v => v.length <= 25 || 'Max 25 characters']"
            >
              <template v-slot:label v-if="ttlText_focus">
                <span >{{$t('widgets.ttlTxt')}}</span>
                <span v-if="ttlText.length > 4" style="position: absolute;right: 18px;">{{ttlText.length}}/</span>
                <span v-if="ttlText.length > 4" style="position: absolute;right: 0px;">25</span>
              </template>
            </v-text-field>
          </v-row>
        </v-col>
      </v-row>
      <v-row align="start" style="width:100%" class="mt-0 pt-0">
        <v-col cols="1" class=""></v-col>
        <v-col cols="3" class="">
          <v-row align="start" class="mr-2">
            <v-select
              dense
              :items="fontLst"
              :label="$t('widgets.fontFamily')"
              class="text-fonts label-scale"
              v-model="ttlFont"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="4" class="mr-0 ml-3">
          <v-row align="start" class="mr-2">
            <ColorSelect
              :color="ttlColor"
              :label="$t('widgets.fontColor')"
              v-on:selectedColor="setTtlClr($event)"
              :key="ttlKey"
              class="item-scale"
            />
          </v-row>
        </v-col>
        <v-col cols="2" class="ml-0 pl-0">
          <v-row align="start" class="mr-0">
            <v-select
              dense
              :items="fontWeight"
              :label="$t('widgets.fontWght')"
              class="text-fonts label-scale"
              v-model="ttlFontWght"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="1" class="ml-0 pl-0 ml-4">
          <v-row align="start" class="pl-0">
            <v-select
              dense
              :items="titleFontSize"
              :label="$t('widgets.fontSize')"
              class="text-fonts label-scale"
              v-model="ttlFontSize"
            >
            </v-select>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>

    <v-container fluid style="height:auto;width:100%" class="mb-0 pb-0">
      <v-row align="start" style="height:30% width:100%" class="mb-0 pb-0">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <v-row align="start" style="height:70%" class="mb-0 pb-0 wdg_disc_codes">
            <v-textarea
              :label="$t('widgets.msgTxt')"
              v-model="msgTxt"
              class="text_area_font text-fonts"
              maxlength="280"
              @focus="msgTxt_focus = true"
              @focusout="msgTxt_focus = false"
              rows="2"
              :rules=" [v => v.length <= 280 || 'Max 280 characters']"
            >
              <template v-slot:label v-if="msgTxt_focus">
                <span >{{$t('widgets.msgTxt')}}</span>
                <span v-if="msgTxt.length > 4" style="position: absolute;right: 26px;">{{msgTxt.length}}/</span>
                <span v-if="msgTxt.length > 4" style="position: absolute;right: 0px;">280</span>
              </template>
            </v-textarea>
          </v-row>
        </v-col>
      </v-row>
      <v-row align="start" style="width:100%" class="mt-0 pt-0">
        <v-col cols="1" class=""></v-col>
        <v-col cols="3" class="">
          <v-row align="start" class=" mr-2">
            <v-select
              dense
              :items="fontLst"
              :label="$t('widgets.fontFamily')"
              class="text-fonts label-scale"
              v-model="msgFont"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="4" class=" mr-0 ml-3">
          <v-row align="start" class="mr-2">
            <ColorSelect
              :color="msgColor"
              :label="$t('widgets.fontColor')"
              v-on:selectedColor="setMsgClr($event)"
              :key="msgKey"
              class="item-scale"
            />
          </v-row>
        </v-col>
        <v-col cols="2" class="ml-0 pl-0">
          <v-row align="start" class="mr-0">
            <v-select
              dense
              :items="fontWeight"
              :label="$t('widgets.fontWght')"
              class="text-fonts label-scale"
              v-model="msgFontWght"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="1" class="ml-0 pl-0 ml-4">
          <v-row align="start" class=" pl-0">
            <v-select
              dense
              :items="fontSize"
              :label="$t('widgets.fontSize')"
              class="text-fonts label-scale"
              v-model="msgFontSize"
            >
            </v-select>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container
      fluid
      style="height:auto;width:100%"
      class="mb-0 pb-0 wdg_disc_codes"
      v-show="radioSelect == 'Checkbox'"
    >
      <v-row style="height:20%;width:100%" class="pa-0 ma-0" align="start">
        <v-col cols="5 offset-1" class="px-0">
          <v-row class="my-2 px-0" style="width:100%" align="center">
            <h3 class="subs_title gath_msg">{{ $t("widgets.btnHdr") }}</h3>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row class="my-0 mr-2" style="width:100%" justify="end">
            <TooltipIcon
              :posRight="true"
              :nudgeBottom="30"
              :nudgeLeft="5"
              :txt="$t('widgets.btnInfo')"
              class="infoicon_scale pt-0 mt-0"
            />
          </v-row>
        </v-col>
      </v-row>

      <!-- Start of submit group  -->
      <v-row align="center" style="height:30% width:100%" class="mb-0 pb-0">
        <v-col cols="1"></v-col>
        <v-col cols="5">
          <v-row align="center" style="height:100%" class="">
            <v-text-field
              :label="$t('widgets.btnTxt')"
              v-model="btnTxt"
              class="text-fonts"
              dense
              maxlength="25"
              @focus="btnTxt_focus = true"
              @focusout="btnTxt_focus = false"
              :rules=" [v => v.length <= 25 || 'Max 25 characters']"
            >
              <template v-slot:label v-if="btnTxt_focus">
                <span >{{$t('widgets.btnTxt')}}</span>
                <span v-if="btnTxt.length > 4" style="position: absolute;right: 18px;">{{btnTxt.length}}/</span>
                <span v-if="btnTxt.length > 4" style="position: absolute;right: 0px;">25</span>
              </template>
            </v-text-field>
          </v-row>
        </v-col>
        <v-col cols="5" class="mr-0 ml-6">
          <v-row align="center" style="height:100%" class="">
            <ColorSelect
              :color="btnBcgColor"
              :label="$t('widgets.btnColor')"
              v-on:selectedColor="setBtnBcgClr($event)"
              :key="btnBcgKey"
              class="item-scale"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row align="start" style="width:100%" class="mt-0 pt-0">
        <v-col cols="1" class="mt-0 pt-0"></v-col>
        <v-col cols="3" class="">
          <v-row align="start" class="mr-2">
            <v-select
              dense
              :items="fontLst"
              :label="$t('widgets.fontFamily')"
              class="text-fonts label-scale"
              v-model="btnFont"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="4" class="mr-0 ml-3">
          <v-row align="start" class="mt-0 pt-0 mr-2">
            <ColorSelect
              :color="btnFntColor"
              :label="$t('widgets.fontColor')"
              v-on:selectedColor="setBtnFntClr($event)"
              :key="btnFntKey"
              class="item-scale"
              style="height:100%"
            />
          </v-row>
        </v-col>
        <v-col cols="2" class="ml-1 pl-0">
          <v-row align="start" class="mt-0 pt-0 mr-0">
            <v-select
              dense
              :items="fontWeight"
              :label="$t('widgets.fontWght')"
              class="text-fonts label-scale"
              v-model="btnFontWght"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="1" class=" ml-2 mr-0 pr-0">
          <v-row align="start" class="mt-0 pt-0 pl-0">
            <v-select
              dense
              :items="btnfontSizeArr"
              :label="$t('widgets.fontSize')"
              class="text-fonts label-scale"
              v-model="btnFontSize"
            >
            </v-select>
          </v-row>
        </v-col>
      </v-row>

      <v-row align="start" style="width:100%" class="mt-0 pt-0">
        <v-col cols="1" class="mt-0 pt-0"></v-col>
        <v-col cols="3" class="">
          <v-row align="start" class="mr-0">
            <v-select
              dense
              :items="btnCrnrArr"
              :label="$t('widgets.btnCrnr')"
              class="text-fonts label-scale"
              v-model="btnCrnr"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="2" class=" mr-2">
          <v-row align="start" class="mt-0 pt-0 pl-2">
            <v-select
              dense
              :items="btnBrdrSzArr"
              :label="$t('widgets.btnBrdrSz')"
              class="text-fonts label-scale"
              v-model="btnBrdrSz"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="4" class="mr-0 ml-3">
          <v-row align="start" class="mt-0 pt-0 mr-2">
            <ColorSelect
              :color="btnBrdrColor"
              :label="$t('widgets.btnBrdrClr')"
              v-on:selectedColor="setBtnBrdrClr($event)"
              :key="clrBtnBrdrKey"
              class="item-scale"
              style="height:100%"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container fluid style="height:auto;width:100%" class="mb-0 pb-0">
      <v-row style="height:20%;width:100%" class="pa-0 ma-0" align="start">
        <v-col cols="5 offset-1" class="px-0">
          <v-row class="my-2 " style="width:100%" align="center">
            <h3 class="subs_title gath_msg">{{ $t("widgets.cnclHdr") }}</h3>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row class="my-0 mr-2" style="width:100%" justify="end">
            <TooltipIcon
              :posRight="true"
              :nudgeBottom="30"
              :nudgeLeft="5"
              :txt="$t('widgets.cnclInfo')"
              class="infoicon_scale pt-0 mt-0"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row align="start" style="height:30% width:100%" class="mb-0 pb-0 wdg_disc_codes">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <v-row align="start" style="height:70%" class="mb-0 pb-0">
            <v-text-field
              :label="$t('widgets.cnclTxt')"
              v-model="cnclTxt"
              class="text-fonts"
              maxlength="25"
              @focus="cnclTxt_focus = true"
              @focusout="cnclTxt_focus = false"
              :rules=" [v => v.length <= 25 || 'Max 25 characters']"
            >
              <template v-slot:label v-if="cnclTxt_focus">
                <span >{{$t('widgets.cnclTxt')}}</span>
                <span v-if="cnclTxt.length > 4" style="position: absolute;right: 18px;">{{cnclTxt.length}}/</span>
                <span v-if="cnclTxt.length > 4" style="position: absolute;right: 0px;">25</span>
              </template>
            </v-text-field>
          </v-row>
        </v-col>
      </v-row>
      <v-row align="start" style="width:100%" class="mt-0 pt-0">
        <v-col cols="1" class=""></v-col>
        <v-col cols="3" class="">
          <v-row align="start" class=" mr-2">
            <v-select
              dense
              :items="fontLst"
              :label="$t('widgets.fontFamily')"
              class="text-fonts label-scale"
              v-model="cnclFont"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="4" class="mr-0 ml-3">
          <v-row align="start" class=" mr-2">
            <ColorSelect
              :color="cnclColor"
              :label="$t('widgets.fontColor')"
              v-on:selectedColor="setCnclClr($event)"
              :key="cnclKey"
              class="item-scale"
            />
          </v-row>
        </v-col>
        <v-col cols="2" class=" ml-0 pl-0">
          <v-row align="start" class=" mr-0">
            <v-select
              dense
              :items="fontWeight"
              :label="$t('widgets.fontWght')"
              class="text-fonts label-scale"
              v-model="cnclFontWght"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="1" class=" ml-0 pl-0 ml-4">
          <v-row align="start" class=" pl-0">
            <v-select
              dense
              :items="fontSize"
              :label="$t('widgets.fontSize')"
              class="text-fonts label-scale"
              v-model="cnclFontSize"
            >
            </v-select>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import TooltipIcon from "@/components/svgIcons/TooltipIcon.vue";
import ArrowUp from "@/assets/icons/GetSub/arrow-up-inactiv.svg";
import ArrowDown from "@/assets/icons/GetSub/arrow-down-inactiv.svg";
import ColorSelect from "@/components/GlobalComponents/ColorSelect.vue";
import { mapGetters } from "vuex";

export default {
  name: "WidgetProps",
  components: { TooltipIcon, ColorSelect
    ,ArrowUp,ArrowDown
  },
  data() {
    return {
      live: false,
      radioSelect: "",
      headerColor: "#FFFFFF",
      bcgColor: "#FFFFFF",
      hdrClrKey: 0,
      bdyClrKey: 0,
      ttlText: "",
      ttlFont: "",
      fontLst: [
        "Arial",
        "Georgia",
        "Helvetica",
        "Impact",
        "Open sans",
        "Poppins",
        "Roboto",
        "Times new roman",
        "Verdana",
      ],
      fontSize: [12, 13, 14, 15, 16, 17, 18, 19, 20],
      titleFontSize: [23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 34, 36],
      fontWeight: ["lighter", "normal", "bolder"],
      ttlFontWght: 0,
      ttlFontSize: 0,
      ttlClrKey: 0,
      msgTxt: "",
      msgFont: "",
      msgClrKey: 0,
      msgFontWght: 0,
      msgFontSize: 0,
      cnclTxt: "",
      cnclFont: "",
      cnclClrKey: 0,
      cnclFontWght: 0,
      cnclFontSize: 0,
      btnTxt: "",
      btnBcgClrKey: 0,
      btnFont: "",
      btnFntClrKey: 0,
      btnFontWght: 0,
      btnFontSize: 0,
      btnfontSizeArr: [8, 9, 10, 11, 12, 14, 18, 24],
      btnCrnrArr: ["Round", "Tile"],
      btnCrnr: "",
      btnBrdrSzArr: [1, 2, 3, 4, 5, 6],
      btnBrdrSz: 0,
      btnBrdrClrKey: 0,
      def_selected:true,
      discount_selected:false,
      coneData: [
        { id:1,connection: true, title: "Facebook" },
        { id:2,connection: false, title: "SMS" },
        { id:3,connection: false, title: "WhatsApp" },
      ],
      disCodeInst:null,
      discount_statement:"",
      discount_code:"",
      copy_discount_code_button :"",
      apply_discount_instruction:"",
      statusWidgets:null,
      subType:null,
      subscribe_type:null,
      notSel:false,
      isGdprAffected: false,
      discCodeNotValid:false,
      nameRules: [
        v => !!v || 'Name is required',
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      discount_statement_focus:false,
      discount_code_focus:false,
      apply_discount_instruction_focus:false,
      copy_discount_code_button_focus:false,
      ttlText_focus:false,
      msgTxt_focus:false,
      btnTxt_focus:false,
      cnclTxt_focus:false,
      popup_triggers_add_to_cart:false,
      popup_triggers_exit_intent:false,
      triggerMustBe:false,
      activeIconArrow:false,
      activeIconArrowSecond:false,
    };
  },
  methods: {
    wdgtLive() {
      this.$store.dispatch("updWdgtLive", this.live);
    },
    setHdrClr(selectedColor) {
      this.headerColor = selectedColor;
      this.$store.dispatch("updWdgtHdrClr", selectedColor);
    },
    setBdyClr(selectedColor) {
      this.bcgColor = selectedColor;
      this.$store.dispatch("updWdgtBdyClr", selectedColor);
    },
    hdrIncr() {
      this.hdrClrKey++;
    },
    bdyIncr() {
      this.bdyClrKey++;
    },
    ttlIncr() {
      this.ttlClrKey++;
    },
    msgIncr() {
      this.msgClrKey++;
    },
    cnclIncr() {
      this.cnclClrKey++;
    },
    btnBrdrIncr() {
      this.btnBrdrClrKey++;
    },
    btnBcgIncr() {
      this.btnBcgClrKey++;
    },
    btnFntIncr() {
      this.btnFntClrKey++;
    },
    setTtlClr(selectedColor) {
      this.$store.dispatch("updTtlBdyClr", selectedColor);
    },
    setMsgClr(selectedColor) {
      this.$store.dispatch("updMsgBdyClr", selectedColor);
    },
    setCnclClr(selectedColor) {
      this.$store.dispatch("updWdgtCnclClr", selectedColor);
    },
    setBtnBcgClr(selectedColor) {
      this.$store.dispatch("updWdgtBtnBcgClr", selectedColor);
    },
    setBtnFntClr(selectedColor) {
      this.$store.dispatch("updWdgtBtnFntClr", selectedColor);
    },
    setBtnBrdrClr(selectedColor) {
      this.$store.dispatch("updWdgtBtnBrdrClr", selectedColor);
    },
    svChanges() {
      if((this.discount_selected == 'subscribe' && this.discount_code !== '') || this.def_selected == 'deafult'){
        this.popup_triggers_add_to_cart == false && this.popup_triggers_exit_intent == false ? this.triggerMustBe = true : this.triggerMustBe = false
        if(this.triggerMustBe == false){
          this.discCodeNotValid = false;this.triggerMustBe = false
          if(this.coneData[0].connection == true || this.coneData[1].connection == true || this.coneData[2].connection == true){
            this.def_selected == null || this.def_selected == false || this.def_selected == ""
              ? this.subscribe_type = "subscribe" : this.subscribe_type = "default"
            let objWidg = {
              coneData:this.coneData,
              subscribe_type:this.subscribe_type,
              discount_statement:this.discount_statement,
              discount_code:this.discount_code,
              copy_discount_code_button:this.copy_discount_code_button,
              apply_discount_instruction:this.apply_discount_instruction,
            };
            this.$store.dispatch("updWdgtDiscForm",objWidg)
            // this.$store.commit('SAVE_WIDGET_FORM',objWidg)
            this.$store.dispatch("updIsLoading", true).then(() => {
              this.$store.dispatch
              ("setWdgts").then((response) => {
                if (response) {
                  this.$store.dispatch("getStepsCompleted");
                  this.$store.dispatch("getWidgets").then(() => {
                    this.$store.dispatch("updIsLoading", false);
                  });
                }
              });
            });
          } else this.notSel = true
        }
      }else this.discCodeNotValid = true
    },
    btMove(arr,old_index,new_index){
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      this.coneData = arr
      arr[0].id = 1
      arr[1].id = 2
      arr[2].id = 3
      this.coneData = arr
      return arr; // for testing
    },
    tpMove(arr,old_index,new_index){
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      arr[0].id = 1
      arr[1].id = 2
      arr[2].id = 3
      this.coneData = arr
      return arr; // for testing

    },
    // array_move(arr, old_index, new_index) {
    //   if (new_index >= arr.length) {
    //     var k = new_index - arr.length + 1;
    //     while (k--) {
    //       arr.push(undefined);
    //     }
    //   }
    //   arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    //   arr[0].id = 1
    //   arr[1].id = 2
    //   arr[2].id = 3
    //   this.coneData = arr
    //   return arr; // for testing
    // },

// returns [2, 1, 3]
// console.log(array_move([1, 2, 3], 0, 1));
    rev(){
      if(this.coneData[0].id == 1 ){
        this.coneData[0].id = 2
        this.coneData[1].id = 1
      }else {
        this.coneData[0].id = 1
        this.coneData[1].id = 2
      }
      setTimeout(() => this.coneData.reverse(), 200);
    },
    changesWidg(){
      if(this.statusWidgets.facebook.position == 1 && this.statusWidgets.sms.position == 2){
        this.detectEuRegion == true ? this.coneData[0].connection = false
        : this.coneData[0].connection = this.statusWidgets.facebook.enabled
        this.coneData[0].id = this.statusWidgets.facebook.position
        this.coneData[0].title = "Facebook"
        this.coneData[1].connection = this.statusWidgets.sms.enabled
        this.coneData[1].id = this.statusWidgets.sms.position
        this.coneData[1].title = "SMS"
        this.coneData[2].connection = this.statusWidgets.whatsapp.enabled
        this.coneData[2].id = this.statusWidgets.whatsapp.position
        this.coneData[2].title = "Whatsapp"
      } else if(this.statusWidgets.facebook.position == 1  && this.statusWidgets.sms.position == 3){
        this.detectEuRegion == true ? this.coneData[0].connection = false
          : this.coneData[0].connection = this.statusWidgets.facebook.enabled
        this.coneData[0].id = this.statusWidgets.facebook.position
        this.coneData[0].title = "Facebook"
        this.coneData[1].connection = this.statusWidgets.whatsapp.enabled
        this.coneData[1].id = this.statusWidgets.whatsapp.position
        this.coneData[1].title = "Whatsapp"
        this.coneData[2].connection = this.statusWidgets.sms.enabled
        this.coneData[2].id = this.statusWidgets.sms.position
        this.coneData[2].title = "SMS"
      }else if(this.statusWidgets.facebook.position == 2 && this.statusWidgets.sms.position == 1){
        this.coneData[0].connection = this.statusWidgets.sms.enabled
        this.coneData[0].id = this.statusWidgets.sms.position
        this.coneData[0].title = "SMS"
        this.detectEuRegion == true ? this.coneData[1].connection = false
          : this.coneData[1].connection = this.statusWidgets.facebook.enabled
        this.coneData[1].id = this.statusWidgets.facebook.position
        this.coneData[1].title = "Facebook"
        this.coneData[2].connection = this.statusWidgets.whatsapp.enabled
        this.coneData[2].id = this.statusWidgets.whatsapp.position
        this.coneData[2].title = "Whatsapp"
      }else if(this.statusWidgets.facebook.position == 3 && this.statusWidgets.sms.position == 1){
        this.coneData[0].connection = this.statusWidgets.sms.enabled
        this.coneData[0].id = this.statusWidgets.sms.position
        this.coneData[0].title = "SMS"
        this.coneData[1].connection = this.statusWidgets.whatsapp.enabled
        this.coneData[1].id = this.statusWidgets.whatsapp.position
        this.coneData[1].title = "Whatsapp"
        this.detectEuRegion == true ? this.coneData[2].connection = false
          : this.coneData[2].connection = this.statusWidgets.facebook.enabled
        this.coneData[2].id = this.statusWidgets.facebook.position
        this.coneData[2].title = "Facebook"
      }else if(this.statusWidgets.facebook.position == 2 && this.statusWidgets.sms.position == 3){
        this.coneData[0].connection = this.statusWidgets.whatsapp.enabled
        this.coneData[0].id = this.statusWidgets.whatsapp.position
        this.coneData[0].title = "Whatsapp"
        this.coneData[2].connection = this.statusWidgets.sms.enabled
        this.coneData[2].id = this.statusWidgets.sms.position
        this.coneData[2].title = "SMS"
        this.detectEuRegion == true ? this.coneData[1].connection = false
          : this.coneData[1].connection = this.statusWidgets.facebook.enabled
        this.coneData[1].id = this.statusWidgets.facebook.position
        this.coneData[1].title = "Facebook"
      }else if(this.statusWidgets.facebook.position == 3 && this.statusWidgets.sms.position == 2){
        this.coneData[0].connection = this.statusWidgets.whatsapp.enabled
        this.coneData[0].id = this.statusWidgets.whatsapp.position
        this.coneData[0].title = "Whatsapp"
        this.coneData[1].connection = this.statusWidgets.sms.enabled
        this.coneData[1].id = this.statusWidgets.sms.position
        this.coneData[1].title = "SMS"
        this.detectEuRegion == true ? this.coneData[2].connection = false
          : this.coneData[2].connection = this.statusWidgets.facebook.enabled
        this.coneData[2].id = this.statusWidgets.facebook.position
        this.coneData[2].title = "Facebook"
      }
      // else {
      //   this.detectEuRegion == true ? this.coneData[1].connection = false
      //   : this.coneData[1].connection = this.statusWidgets.facebook.enabled
      //   this.coneData[1].id = this.statusWidgets.facebook.position
      //   this.coneData[1].title = "Facebook"
      //   this.coneData[0].connection = this.statusWidgets.sms.enabled
      //   this.coneData[0].id = this.statusWidgets.sms.position
      //   this.coneData[0].title = "SMS"
      // }
      if(this.subType == "subscribe"){
        this.discount_selected = 'subscribe'
        this.def_selected = ''
      }else this.def_selected = 'deafult' , this.discount_selected = ''
    },
    getDisplayAvailabilityNotice(ite) {
      return ite.title;
    }
  },
  computed: {
    ...mapGetters(["getWidgetsState", "getSettingsState","getWidgEU","getSubPlan","getInstanceId"]),
    upgrdUrl() {
      return `https://www.wix.com/apps/upgrade/1c15809f-0715-427d-969d-3f0f3939418f?appInstanceId=${this.getInstanceId}`;
    },
    subPlan(){
      return this.getSubPlan
      // return "Free"
    },
    detectEuRegion(){
      return this.getWidgEU
    },
    detectChange() {
      return this.getWidgetsState.changesSaved;
    },
    liveLbl() {
      return this.live ? this.$t("widgets.liveLbl") : this.$t("widgets.offLbl");
    },
    hdrColor() {
      this.hdrIncr();
      return this.getWidgetsState.header_background_color;
    },
    bdyColor() {
      this.bdyIncr();
      return this.getWidgetsState.popup_background_color;
    },
    hdrKey() {
      return "h" + this.hdrClrKey;
    },
    bdyKey() {
      return "b" + this.bdyClrKey;
    },
    ttlKey() {
      return "ttl" + this.ttlClrKey;
    },
    ttlColor() {
      this.ttlIncr();
      return this.getWidgetsState.pop_up_title_font_color;
    },
    msgColor() {
      this.msgIncr();
      return this.getWidgetsState.pop_up_message_font_color;
    },
    cnclColor() {
      this.cnclIncr();
      return this.getWidgetsState.pop_up_cancel_font_color;
    },
    btnBcgColor() {
      this.btnBcgIncr();
      return this.getWidgetsState.button_background;
    },
    msgKey() {
      return "msg" + this.msgClrKey;
    },
    cnclKey() {
      return "cncl" + this.cnclClrKey;
    },
    btnBcgKey() {
      return "btnBcg" + this.btnBcgClrKey;
    },
    btnFntColor() {
      this.btnFntIncr();
      return this.getWidgetsState.button_font_color;
    },
    btnFntKey() {
      return "btnFnt" + this.btnFntClrKey;
    },
    btnBrdrColor() {
      this.btnBrdrIncr();
      return this.getWidgetsState.button_border_color;
    },
    clrBtnBrdrKey() {
      return "btnBrdr" + this.btnBrdrClrKey;
    },
    getPageSettingsLink() {
      if (this.getSettingsState.facebook_page_name == "") {
        return `https://www.facebook.com/pages`;
      } else {
        return `https://www.facebook.com/${this.getSettingsState.facebook_page_id}/settings/?tab=messenger_platform`;
      }
    },
  },
  watch: {
    coneData: {
      deep: true,
      handler() {
        this.notSel = false
        this.$store.dispatch("updWdgtConcType", this.coneData);
      }
    },
    popup_triggers_add_to_cart(newValue){
      this.$store.dispatch("updWdgtTriggerAddToCart", newValue);
    },
    popup_triggers_exit_intent(newValue){
      this.$store.dispatch("updWdgtTriggerExitIntent",newValue);
    },
    def_selected(newValue) {
      if((newValue == '' || newValue == null) && this.discount_selected != 'subscribe'){
        setTimeout(() => {this.def_selected = 'deafult'} , 1)
      }else this.$store.dispatch("updWdgtDefSel", newValue);
    },
    discount_selected(newValue) {
      if((newValue == '' || newValue == null) && this.def_selected != 'deafult'){
        setTimeout(() => {this.discount_selected = 'subscribe'} , 1)
        setTimeout(() => {this.$store.dispatch("changeSavedWdgt",false)} , 10)
      }else this.$store.dispatch("updWdgtDefSel", newValue);
    },
    radioSelect(newValue) {
      this.$store.dispatch("updWdgtType", newValue);
    },
    discount_statement(newValue) {
      this.$store.dispatch("updWdgtDiscStatment", newValue);
    },
    copy_discount_code_button(newValue){
      this.$store.dispatch("updWdgtDiscCopyCode", newValue);
      this.discCodeNotValid = false
    },
    discount_code(newValue) {
      this.$store.dispatch("updWdgtDiscCode", newValue);
      this.discCodeNotValid = false
    },
    apply_discount_instruction(newValue) {
      this.$store.dispatch("updWdgtDiscInst", newValue);
    },
    ttlText(newValue) {
      this.$store.dispatch("updWdgtTtl", newValue);
    },
    ttlFont(newValue) {
      this.$store.dispatch("updWdgtTtlFnt", newValue);
    },
    ttlFontWght(newValue) {
      this.$store.dispatch("updWdgtTtlFntWght", newValue);
    },
    ttlFontSize(newValue) {
      this.$store.dispatch("updWdgtTtlFntSize", newValue);
    },
    msgTxt(newValue) {
      this.$store.dispatch("updWdgtMsg", newValue);
    },
    msgFont(newValue) {
      this.$store.dispatch("updWdgtMsgFnt", newValue);
    },
    msgFontWght(newValue) {
      this.$store.dispatch("updWdgtMsgFntWght", newValue);
    },
    msgFontSize(newValue) {
      this.$store.dispatch("updWdgtMsgFntSz", newValue);
    },
    cnclTxt(newValue) {
      this.$store.dispatch("updWdgtCnclTxt", newValue);
    },
    cnclFont(newValue) {
      this.$store.dispatch("updWdgtCnclFnt", newValue);
    },
    cnclFontWght(newValue) {
      this.$store.dispatch("updWdgtCnclFntWght", newValue);
    },
    cnclFontSize(newValue) {
      this.$store.dispatch("updWdgtCnclFntSz", newValue);
    },
    btnTxt(newValue) {
      this.$store.dispatch("updWdgtBtnTxt", newValue);
    },
    btnFont(newValue) {
      this.$store.dispatch("updWdgtBtnFnt", newValue);
    },
    btnFontWght(newValue) {
      this.$store.dispatch("updWdgtBtnFntWght", newValue);
    },
    btnFontSize(newValue) {
      this.$store.dispatch("updWdgtBtnFntSz", newValue);
    },
    btnCrnr(newValue) {
      this.$store.dispatch("updWdgtBtnCrnr", newValue);
    },
    btnBrdrSz(newValue) {
      this.$store.dispatch("updWdgtBtnBrdrSz", newValue);
    },
  },
  mounted() {
    this.$store.dispatch("updIsLoading", true).then(() => {
      this.$store.dispatch("getWidgets").then((response) => {
        if (response) {
          this.radioSelect = this.$store.getters.getWidgetsState.facebook_widget_type;
          this.ttlText = this.$store.getters.getWidgetsState.pop_up_title;
          this.ttlFont = this.$store.getters.getWidgetsState.pop_up_title_font_family;
          this.ttlFontWght = this.$store.getters.getWidgetsState.pop_up_title_font_type;
          this.ttlFontSize = this.$store.getters.getWidgetsState.pop_up_title_font_size;
          this.msgTxt = this.$store.getters.getWidgetsState.pop_up_message;
          this.msgFont = this.$store.getters.getWidgetsState.pop_up_message_font_family;
          this.msgFontWght = this.$store.getters.getWidgetsState.pop_up_message_font_type;
          this.msgFontSize = this.$store.getters.getWidgetsState.pop_up_message_font_size;
          this.cnclTxt = this.$store.getters.getWidgetsState.pop_up_cancel;
          this.cnclFont = this.$store.getters.getWidgetsState.pop_up_cancel_font_family;
          this.cnclFontWght = this.$store.getters.getWidgetsState.pop_up_cancel_font_type;
          this.cnclFontSize = this.$store.getters.getWidgetsState.pop_up_cancel_font_size;
          this.btnTxt = this.$store.getters.getWidgetsState.button_text;
          this.btnFont = this.$store.getters.getWidgetsState.button_font_family;
          this.btnFontWght = this.$store.getters.getWidgetsState.button_font_type;
          this.btnFontSize = this.$store.getters.getWidgetsState.button_font_size;
          this.btnCrnr = this.$store.getters.getWidgetsState.button_corners;
          this.btnBrdrSz = this.$store.getters.getWidgetsState.button_border_size;
          this.live = this.$store.getters.getWidgetsState.active;
          this.$store.dispatch("getSettings").then(() => {
            this.$store.dispatch("updIsLoading", false);
          });
          this.isGdprAffected =
            this.$store.getters.getWidgetsState.is_gdpr_affected;
          this.popup_triggers_add_to_cart = this.$store.getters.getWdgPopupTriggers.add_to_cart
          this.popup_triggers_exit_intent = this.$store.getters.getWdgPopupTriggers.exit_intent
          if(this.subPlan == 'Free'){
            this.popup_triggers_exit_intent = false;
          }
        }
      });
    });
    setTimeout(() => ( this.subType = this.$store.state.widgetVars.subscribe_type,this.statusWidgets = this.$store.state.widgetVars.enabled_widgets,
      this.discount_statement = this.$store.state.widgetVars.discount_statement,
      this.discount_code = this.$store.state.widgetVars.discount_code,
      this.copy_discount_code_button = this.$store.state.widgetVars.copy_discount_code_button,
      this.apply_discount_instruction = this.$store.state.widgetVars.apply_discount_instruction,this.changesWidg()), 500)

  },

};
</script>

<style scoped>
.cursPoint{
  cursor: pointer !important;
}
.tpMove{
  color: transparent !important;position: relative;top:-10px !important;left:-9px !important;height: 18px !important;width: 150%
}
.bottomMove{
  height: 15px; color: transparent !important;position: relative;top:-25px !important;left:-9px !important;width:150%
}
.width_361{
  max-width: 361px !important;
}
.red-valid-border {
  /*width: 450px;*/
  border: 2px #ff0000 solid !important;
  animation: blink 1s !important;
  animation-iteration-count: 2 !important;
@keyframes blink {
  50% {
    border-color: #fff !important;
  }
}
}

.trigger_ft_span{
  text-align: left !important;
  font: normal normal bold 12px/19px Poppins;
  font-family: Poppins !Important;
  font-size: 12px !important;
  font-weight: normal !important;
  letter-spacing: 0px !important;
  /*color: #5686F6 !important;*/
  opacity: 1 !important;
}
.brd_dot{
  border: 2px dashed #323F4F;
  opacity: 1;
}
.trigger_text{
  text-align: left;
  font-size: 12px !important;
  font-family: Poppins;
  font-weight: normal;
  letter-spacing: 0px;
  color: #323F4F;
}
.upgrade_text_yellow{
  text-align: left;
  text-decoration: underline;
  font: normal normal 600 12px/14px Poppins;
  letter-spacing: 0px;
  color: #F5A623;
}
.trigger_width_230{
  width:230px !important;
}
.blue_color{
  color: #5686f6 !Important;
  text-align: left !important;
  font: normal normal bold 12px/19px Poppins;
  font-weight: normal !important;
  font-size: 12px !important;
  font-family: Poppins !important;
  letter-spacing: 0px !important;
  color: #5686F6 !important;
  opacity: 1 !important;
}
.text_area_font{
  font-size: 16px !important;
  color: #323F4F !important;
  font-weight: normal;
}
.parent_gat_message{
  margin-bottom: 36px !important;
}
.widg_hint_txt{
  width: 89% !important;
}
  .Eu_hint_NotAv{
    height: 34px !important;
    align-items: center !important;
    padding-bottom: 0px !important;
  }
.cursor_pointer{
  cursor: pointer;
}
/*.txt_overflow{*/
/*  max-width: 205px;*/
/*  text-overflow: ellipsis;*/
/*  white-space: nowrap;*/
/*}*/
/*}*/
@media screen and (max-width: 1600px) and (min-width: 1350px) {
  .tpMove{
    width: 200%
  }
  .bottomMove{
    width: 200%
  }
}
@media screen and (max-width: 1349px) and (min-width: 1100px) {
  .tpMove{
    width: 300%
  }
  .bottomMove{
    width: 300%
  }
}
@media screen and (max-width: 1099px) and (min-width: 900px) {
  .tpMove{
    width: 500%
  }
  .bottomMove{
    width: 500%
  }
}

</style>

<style>
/*.txt_overflow_wdg_cdc .v-input input{*/
/*  max-width: 205px;*/
/*  text-overflow: ellipsis;*/
/*  white-space: nowrap;*/
/*}*/
.arrow_icon_fill path{
  /*fill:#5686F6 !important;*/
  stroke:#5686F6 !important;
}
.wdg_disc_codes .v-label{
  display: block !important;
  width: 135% !important;
}
.dis_code .v-messages__message{
  display: none;
}
.not_valid .v-text-field input{
  border: 2px solid red !important;
}
.par_spc .v-input__slot{
  margin-bottom: 0px !important;
}

.par_disc_fields .v-text-field{
  padding-top: 0px !important;
}
.checkbox_widget .v-messages{
  height: 1px !important;
}
.wdgt_font_dims {
  text-align: center !important;
  font: normal normal 12px/29px Poppins !important;
  letter-spacing: 0px !important;

  opacity: 1 !important;
  overflow: hidden !important;
}

.wdgt_btn

.card-scroll {
  overflow: auto;
  scrollbar-width: 2px;
}

.cust-chkbx {
  height: 20px !important;
  width: 20px !important;
  border: 1px solid cornflowerblue;
  border-radius: 2px;
  margin: 2px;
  -webkit-appearance: none;
}

.cursor-hand {
  cursor: pointer;
}

.cust-chkbx:checked {
  background-color: cornflowerblue;
  padding: 1px !important;
  background-size: 2px 2px !important;
  background-clip: content-box;
  color: cornflowerblue;
}

.cust-chkbx-label:checked + label {
  color: cornflowerblue;
  font-weight: bold !important;

}

.cust-chkbx:focus {
  outline-color: transparent;
}

.lbl-props {
  font-size: 85%;
  font-weight: bold;
  padding-inline-start: 5px;
}

.item-scale {
  transform: scale(0.95);
  transform-origin: 0 0;
}

.label-scale {
  transform: scale(0.95);
  transform-origin: 0 0;
}
.text-fonts {
  font-size: 92%;
}
.sv_changes{
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 2px solid #5686F6;
  border-radius: 2px;
  opacity: 1;
  text-align: center;
  font: normal normal 600 12px/29px Poppins;
  letter-spacing: 0px;
  color: #5686F6 !important;
  padding: 0px 30px !important;
}
.subs_title{
  text-align: left !important;
  letter-spacing: 0px !important;
  color: #323F4F !important;
  opacity: 1 !important;
}

.subs_text{
  text-align: left !important;
  font: normal normal 300 10px/14px Poppins !important;
  letter-spacing: 0px !important;
  color: #4E5D6B !important;
  opacity: 1 !important;
  margin-bottom: 7px!important;
}
.checkbox_widget{
  text-align: left;
  font: normal normal normal 12px/19px Poppins;
  letter-spacing: 0px;
  color: #323F4F;
  opacity: 1;
}
.smaller_text{
  text-align: left;
  font: italic normal normal 10px/11px Arial;
  letter-spacing: 0px;
  color: #323F4F;
}
.space_bottom{
  margin-bottom:16px !important;
}
.text_checkbox{
  font: normal normal normal 12px/19px Poppins;
  letter-spacing: 0px;
  color: #323F4F;
  opacity: 1;
}
.connection_row{
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #C9CACB;
  border-radius: 4px;
  opacity: 1;
  padding: 8px 23px !important;
}
.height_row{
  height: 36px !important;
  margin-bottom: 10px !important;
}
.tri_for_hover{
  width: 0;
  height: 0;
  border-top: 60px solid transparent;
  border-bottom: 60px solid transparent;
  border-left: 60px solid green;
}
.pos_smaller{
  position: relative;
  bottom: 12px;
}
.pos_sm_cont{
  position: relative;
  bottom: 20px;
}
.notSel{
  border: 2px solid red !important;
}
.notSelTxt{
  color: red;
}
.notSelSpc{
  position: relative !important;
  bottom: 28px !important;
}
.Sub_Par{
  margin-top: 15px !important;
}
.gath_msg{
  font-family: Poppins;
  font-size: 14px !important;
  line-height: 16px;
}
.pop_con_wdg{
  font-family: Poppins;
  font-size: 16px !important;
}
.disabled_display{
  pointer-events: none !important;
}
.fix_image_pos{
  margin-top: 10px;
  margin-left: 18px;
}
.wdgt_font_dims .v-label{
  font-size: 14px !important;
  color:#4E5D6B !important;
}
.wdgt_font_dims .v-input input{
  font-size: 16px !important;
  color:#323F4F !important;
  font-weight:normal;
}
@media only screen and (max-width: 1799px) {
  .fix_image_pos{
    margin-left: 11px;
  }
}
@media only screen and (max-width: 1399px) {
  .lbl-props {
    font-size: 100%;
  }
  .fix_image_pos{
    margin-left: 17px;
  }
  .disabled_display{
    padding: 0px !important;
  }
  .item-scale {
    transform: scale(0.9);
    transform-origin: 0 0;
  }
  .label-scale {
    transform: scale(0.9);
    transform-origin: 0 0;
  }
  .resp_sp{
    font-size: 90% !important;
    width:100% !important; ;
  }
}
@media only screen and (max-width: 1230px) {
  .lbl-props {
    font-size: 80%;
  }

  .item-scale {
    transform: scale(0.8);
    transform-origin: 0 0;
  }
  .label-scale {
    transform: scale(0.8);
    transform-origin: 0 0;
  }
  .Eu_hint_NotAv{
    font: normal normal 600 10px/37px Poppins !important;
  }
}
@media only screen and (max-width: 1050px) {
  .lbl-props {
    font-size: 75%;
  }
  .fix_image_pos{
    margin-left: 12px;
  }
  .resp_sp{
    font-size: 80% !important;
    width:100% !important; ;
  }
  .item-scale {
    transform: scale(0.8);
    transform-origin: 0 0;
  }
  .label-scale {
    transform: scale(0.8);
    transform-origin: 0 0;
  }
}
@media only screen and (min-width: 1455px) {
  .lbl-props {
    font-size: 95%;
  }

  .wdgt_font_dims {
    font-size: 95% !important;
  }

  .item-scale {
    transform: scale(1);
    transform-origin: 0 0;
  }
  .label-scale {
    transform: scale(1);
    transform-origin: 0 0;
  }
}
</style>
